module.exports = __webpack_public_path__ + "img/Weapon_183.3d2bde25.png";